import { useState, useEffect } from 'react';
import { condoApi } from '../services/api';
import { PersonRegistrationFieldConfig } from '../types/customer/base';

export function usePersonFieldConfig(
  customerId: string | null | undefined,
  personType: string
): PersonRegistrationFieldConfig | null {
  const [fieldConfig, setFieldConfig] = useState<PersonRegistrationFieldConfig | null>(null);

  useEffect(() => {
    if (!customerId) return;
    condoApi.getCustomerSettings(customerId).then(res => {
      const configs = res.data?.condo_data?.person_type_field_configs;
      setFieldConfig(configs?.[personType] ?? null);
    }).catch(() => {});
  }, [customerId, personType]);

  return fieldConfig;
}
